import React from 'react'
import styled from 'styled-components'

interface PageContentProps {
  info?: string
  className?: string
  children: React.ReactNode
}

const PageContent: React.FC<PageContentProps> = (props) => {
  const { info, children, className } = props
  return (
    <StyledPageContent>
      <div className="pagecontent_info" {...(info && { tabIndex: 0 })}>
        {info}
      </div>
      <div className={`pagecontent_main ${className}`}>{children}</div>
    </StyledPageContent>
  )
}

const StyledPageContent = styled.div`
  .pagecontent_info {
    padding: 16px 16px 15px 16px;
    color: ${(props) => props.theme.font.primary};
    font-size: 14px;
    font-weight: normal;
  }
  .pagecontent_main {
    display: flex;
    flex-wrap: wrap;
    margin-left: -16px;
    padding: 0 16px;
  }
`
export default PageContent
